





































































import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { DialogMixin } from "../../../system/mixins";
import { FixedLoading, Separator, } from "../../../system";
import { ComboBoxSelector } from "../../../system/selectors";

type Action = "insertToCaretPosition" | "insertToFirst" | "insertToLast" | "overwrite" | "locate" | "apply";
interface EnableActions {
  insertToCaretPosition?: boolean;
  insertToFirst?: boolean;
  insertToLast?: boolean;
  overwrite?: boolean;
  locate?: boolean;
  apply?: boolean;
}
interface Options {
  input: string;
  language: string;
  actions: EnableActions;
}
interface ResultBase<T extends boolean> {
  isConfirmed: T;
}
interface ResultConfimed extends ResultBase<true> {
  output: string;
  action: Action;
}
interface ResultCancelled extends ResultBase<false> {}
type Result = ResultConfimed | ResultCancelled;

@Component({
  components: {
    FixedLoading,
    ComboBoxSelector,
    Separator,
  }
})
export default class AiTranslationDialog extends Mixins(DialogMixin) {
  options: Options = {
    input: "",
    language: "",
    actions: {},
  };
  input = "";
  output = "";
  action: Action | undefined = undefined;
  isTranslating = false;
  isTranslated = false;
  editinglanguageToTranslate = "";
  outputResult = "";

  data(): any {
    return {
      languageToTranslate: "",
      sourcePhraseWidth: null,
    };
  }
  languageToTranslate: string;
  sourcePhraseWidth: number;

  created(): void {
    this.sourcePhraseWidth = this.phrasePaneDefaultWidth;
  }

  mounted(): void {
    this.languageToTranslate = this.languageOptions.length > 0 ? this.languageOptions[0] : "";
  }

  get phrasePaneDefaultWidth(): number {
    return ((window.innerWidth * 0.95) - 50) / 2;
  }

  get isConfirmable(): boolean {
    return !!this.output;
  }

  get isTranslatable(): boolean {
    return !!this.languageToTranslate;
  }

  get languageOptions(): string[] {
    return this.$configuration.behavior.document.editor.contents.aiTranslation.languages;
  }

  get languageOptionsWidth(): number {
    return Enumerable.from(this.languageOptions).where(o => !!o).toArray().length > 0
      ? Enumerable.from(this.languageOptions).where(o => !!o).select(o => o.length).max() * 25
      : 100;
  }

  get languageOptionsStyle(): any {
    return {
      width: this.languageOptionsWidth + "px",
      margin: "3px",
    };
  }

  get isUndoPossible(): boolean {
    return this.output !== this.outputResult;
  }

  async show(options: Options): Promise<Result> {
    return this.showModal(async () => {
      if (!options.input || !options.language || !options.actions) {
        return {
          isConfirmed: false,
        };
      }
      this.options = options;
      this.input = options.input;
      this.languageToTranslate = options.language;
      this.action = undefined;
      this.isTranslated = false;
      this.output = "";
      this.outputResult = "";
      this.translate();
      await this.waitHidden();
      return this.action
      ? {
        isConfirmed: true,
        output: this.output,
        action: this.action,
      }
      : {
        isConfirmed: false,
      };
    });
  }

  async preTranslate() {
    if (this.isUndoPossible && (await this.$commonDialogs.confirmation.show({
      title: "編集実行確認",
      message: [
        "文章は1度翻訳された後手動で更新されています。",
        "再度翻訳すると編集中の内容は破棄されます。",
        "",
        "編集した内容を破棄して翻訳しますか？",
      ],
      buttons: [
        {
          kind: "danger",
          label: "翻訳",
        },
      ],
      cancellation: {
        isEnable: true,
        label: "編集継続"
      },
    })) === null) {
      return;
    }
    this.translate();
  }

  private async translate() {
    try {
      this.isTranslating = true;
      const translationInfo = await DomainRegistry.instance.externalSystem.getAiService().translate(
        this.input,
        this.languageToTranslate);
      if (translationInfo.isError) {
        this.$error("文章翻訳失敗", "文章翻訳できませんでした。");
        return;
      }
      this.output = translationInfo.output;
      this.outputResult = translationInfo.output;
      this.isTranslated = true;
    } catch (e) {
      this.$error(
        "文章翻訳失敗",
        "文章翻訳できませんでした。",
        e
      );
    } finally {
      this.isTranslating = false;
    }
  }

  async undo() {
    if ((await this.$commonDialogs.confirmation.show({
      title: "編集内容破棄確認",
      message: [
        "文章は翻訳後に手動で変更されています。",
        "",
        "変更内容を破棄して翻訳結果に戻しますか？",
      ],
      buttons: [
        {
          kind: "danger",
          label: "翻訳結果に戻す",
        },
      ],
      cancellation: {
        isEnable: true,
        label: "編集継続"
      },
    })) === null) {
      return;
    }
    this.output = this.outputResult;
  }

  confirm(action: Action): void {
    this.action = action;
    this.isVisible = false;
  }

  close(): void {
    this.isVisible = false;
  }

  getGeometryNames(isWindowRectangleHandleable: boolean): string[] {
    return [
      "ペイン幅",
    ];
  }
}
